import React, { useState, Component, useRef } from 'react';
import { Form, Row, Col, FormGroup, Label, Input, Button, Modal, ModalHeader, ModalBody, ModalFooter, FormFeedback } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import authService from '../api-authorization/AuthorizeService'
import debounce from 'lodash.debounce';


export class DestinosView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            
        };
        if (props.data) {
            this.state.model = props.data
        }
        else {
            this.state.model = { nombre: "" };
        }
        this.state.modelValidation = {
            nombre: this.state.model.nombre != ""
        }
        this.handleChange = this.handleChange.bind(this);
        this.validate = this.validate.bind(this);
        this.validate = debounce(this.validate, 500)
    }

    handleChange(event) {

        var tempModel = this.state.model;
        tempModel[event.target.name] = event.target.value;
        this.setState({
            model: tempModel
        }, () => {
            this.props.setModalBodyState(this.state).then(() => this.validate());
        });
        
    }
    async validate() {
        const token = await authService.getAccessToken();
        const data = JSON.stringify(this.state.model);
        const response = await fetch('api/destinos/validate', {
            method: 'POST',
            headers: !token ? { 'Content-Type': 'application/json' } : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
            body: data
        });
        if (response.ok) {
            var validations = await response.json();
            this.setState({
                modelValidation: validations
            }, () => {
                this.props.setModalBodyState(this.state);
            });
        }
    }
    getValidationValue(value) {
        if (value == null || value == undefined) {
            return true;
        }
        else {
            return value;
        }
    }
    
    render() {
        return (
            <div >
                <Row>
                    <Form>
                        <FormGroup className="col col-md-8">
                            <Label for="Nombre">
                                <FormattedMessage id='Nombre' />
                            </Label>
                            <FormattedMessage id='Nombre'>
                                {(placeholder) =>
                                    <Input
                                        id="nombre"
                                        name="nombre"
                                        placeholder={placeholder}
                                        type="text"
                                        onChange={this.handleChange}
                                        value={this.state.model.nombre}
                                        valid={this.getValidationValue(this.state.modelValidation.nombre)}
                                        invalid={!this.getValidationValue(this.state.modelValidation.nombre)}
                                    />
                                }
                            </FormattedMessage>
                            <FormFeedback>
                                {this.state.model.nombre == '' ? <FormattedMessage id='Este campo es requerido' /> : <FormattedMessage id='Este nombre ya esta siendo usado' /> }
                            </FormFeedback>
                        </FormGroup>
                    </Form>
                </Row>
            </div>
        );
    }

}